import * as i0 from '@angular/core';
import * as i1 from './theme-alain-ui-extensions.module';
import * as i2 from '@angular/common';
import * as i3 from '@angular/forms';
import * as i4 from '@angular/router';
import * as i5 from '@abp/ng.core';
import * as i6 from '@swimlane/ngx-datatable';
import * as i7 from '@abp/ng.theme.shared';
import * as i8 from '@ngx-validate/core';
import * as i9 from '@abp/ng.theme.shared/extensions';
import * as i10 from '@delon/abc/sv';
import * as i11 from 'ng-zorro-antd/core/transition-patch';
import * as i12 from 'ng-zorro-antd/core/wave';
import * as i13 from 'ng-zorro-antd/button';
import * as i14 from 'ng-zorro-antd/menu';
import * as i15 from 'ng-zorro-antd/dropdown';
import * as i16 from 'ng-zorro-antd/icon';
import * as i17 from 'ng-zorro-antd/table';
import * as i18 from 'ng-zorro-antd/spin';
import * as i19 from './components/extensible-table/extensible-table.component';
import * as i20 from './directives/nz-table-row-detail.directive';
import * as i21 from './components/grid-actions/grid-actions.component';
import * as i22 from './components/page-toolbar/page-toolbar.component';
import * as i23 from './directives/nz-table-list.directive';
import * as i24 from './directives/nz-select-default.directive';
import * as i25 from './directives/nz-select-loading.component';
export const ThemeAlainUiExtensionsModuleNgFactory:i0.NgModuleFactory<i1.ThemeAlainUiExtensionsModule> = (null as any);
var _decl0_0:i2.NgClass = (<any>(null as any));
var _decl0_1:i2.NgComponentOutlet = (<any>(null as any));
var _decl0_2:i2.NgForOf<any,any> = (<any>(null as any));
var _decl0_3:i2.NgIf<any> = (<any>(null as any));
var _decl0_4:i2.NgTemplateOutlet = (<any>(null as any));
var _decl0_5:i2.NgStyle = (<any>(null as any));
var _decl0_6:i2.NgSwitch = (<any>(null as any));
var _decl0_7:i2.NgSwitchCase = (<any>(null as any));
var _decl0_8:i2.NgSwitchDefault = (<any>(null as any));
var _decl0_9:i2.NgPlural = (<any>(null as any));
var _decl0_10:i2.NgPluralCase = (<any>(null as any));
var _decl0_11:i3.ɵangular_packages_forms_forms_ba = (<any>(null as any));
var _decl0_12:i3.NgSelectOption = (<any>(null as any));
var _decl0_13:i3.ɵangular_packages_forms_forms_z = (<any>(null as any));
var _decl0_14:i3.DefaultValueAccessor = (<any>(null as any));
var _decl0_15:i3.NumberValueAccessor = (<any>(null as any));
var _decl0_16:i3.RangeValueAccessor = (<any>(null as any));
var _decl0_17:i3.CheckboxControlValueAccessor = (<any>(null as any));
var _decl0_18:i3.SelectControlValueAccessor = (<any>(null as any));
var _decl0_19:i3.SelectMultipleControlValueAccessor = (<any>(null as any));
var _decl0_20:i3.RadioControlValueAccessor = (<any>(null as any));
var _decl0_21:i3.NgControlStatus = (<any>(null as any));
var _decl0_22:i3.NgControlStatusGroup = (<any>(null as any));
var _decl0_23:i3.RequiredValidator = (<any>(null as any));
var _decl0_24:i3.MinLengthValidator = (<any>(null as any));
var _decl0_25:i3.MaxLengthValidator = (<any>(null as any));
var _decl0_26:i3.PatternValidator = (<any>(null as any));
var _decl0_27:i3.CheckboxRequiredValidator = (<any>(null as any));
var _decl0_28:i3.EmailValidator = (<any>(null as any));
var _decl0_29:i3.NgModel = (<any>(null as any));
var _decl0_30:i3.NgModelGroup = (<any>(null as any));
var _decl0_31:i3.NgForm = (<any>(null as any));
var _decl0_32:i3.FormControlDirective = (<any>(null as any));
var _decl0_33:i3.FormGroupDirective = (<any>(null as any));
var _decl0_34:i3.FormControlName = (<any>(null as any));
var _decl0_35:i3.FormGroupName = (<any>(null as any));
var _decl0_36:i3.FormArrayName = (<any>(null as any));
var _decl0_37:i4.RouterOutlet = (<any>(null as any));
var _decl0_38:i4.RouterLink = (<any>(null as any));
var _decl0_39:i4.RouterLinkWithHref = (<any>(null as any));
var _decl0_40:i4.RouterLinkActive = (<any>(null as any));
var _decl0_41:i4.ɵangular_packages_router_router_l = (<any>(null as any));
var _decl0_42:i5.ɵl<any,any> = (<any>(null as any));
var _decl0_43:i5.ɵm = (<any>(null as any));
var _decl0_44:i5.ɵn = (<any>(null as any));
var _decl0_45:i5.ɵr = (<any>(null as any));
var _decl0_46:i5.ɵs = (<any>(null as any));
var _decl0_47:i5.ɵt = (<any>(null as any));
var _decl0_48:i5.ɵu = (<any>(null as any));
var _decl0_49:i5.ɵv = (<any>(null as any));
var _decl0_50:i5.ɵx = (<any>(null as any));
var _decl0_51:i5.ɵy = (<any>(null as any));
var _decl0_52:i5.ɵz = (<any>(null as any));
var _decl0_53:i5.ɵbb = (<any>(null as any));
var _decl0_54:i5.ɵbc = (<any>(null as any));
var _decl0_55:i6.DatatableComponent = (<any>(null as any));
var _decl0_56:i6.DatatableRowDetailDirective = (<any>(null as any));
var _decl0_57:i6.DatatableGroupHeaderDirective = (<any>(null as any));
var _decl0_58:i6.DatatableRowDetailTemplateDirective = (<any>(null as any));
var _decl0_59:i6.DataTableColumnDirective = (<any>(null as any));
var _decl0_60:i6.DataTableColumnHeaderDirective = (<any>(null as any));
var _decl0_61:i6.DataTableColumnCellDirective = (<any>(null as any));
var _decl0_62:i6.DataTableColumnCellTreeToggle = (<any>(null as any));
var _decl0_63:i6.DataTableFooterTemplateDirective = (<any>(null as any));
var _decl0_64:i6.DatatableFooterDirective = (<any>(null as any));
var _decl0_65:i6.DataTablePagerComponent = (<any>(null as any));
var _decl0_66:i6.DatatableGroupHeaderTemplateDirective = (<any>(null as any));
var _decl0_67:i7.ɵa = (<any>(null as any));
var _decl0_68:i7.ɵc = (<any>(null as any));
var _decl0_69:i7.ɵd = (<any>(null as any));
var _decl0_70:i7.ɵe = (<any>(null as any));
var _decl0_71:i7.ɵf = (<any>(null as any));
var _decl0_72:i7.ɵg = (<any>(null as any));
var _decl0_73:i7.ɵh = (<any>(null as any));
var _decl0_74:i7.ɵi = (<any>(null as any));
var _decl0_75:i7.ɵm = (<any>(null as any));
var _decl0_76:i7.ɵn = (<any>(null as any));
var _decl0_77:i7.ɵo = (<any>(null as any));
var _decl0_78:i7.ɵq = (<any>(null as any));
var _decl0_79:i7.ɵs = (<any>(null as any));
var _decl0_80:i7.ɵt = (<any>(null as any));
var _decl0_81:i7.ɵu = (<any>(null as any));
var _decl0_82:i7.ɵv = (<any>(null as any));
var _decl0_83:i7.ɵw = (<any>(null as any));
var _decl0_84:i7.ɵx = (<any>(null as any));
var _decl0_85:i8.ɵa = (<any>(null as any));
var _decl0_86:i8.ɵc = (<any>(null as any));
var _decl0_87:i8.ɵd = (<any>(null as any));
var _decl0_88:i8.ɵe = (<any>(null as any));
var _decl0_89:i9.DateTimePickerComponent = (<any>(null as any));
var _decl0_90:i9.PageToolbarComponent<any> = (<any>(null as any));
var _decl0_91:i9.GridActionsComponent<any> = (<any>(null as any));
var _decl0_92:i9.ExtensibleFormComponent<any> = (<any>(null as any));
var _decl0_93:i9.ExtensibleTableComponent<any> = (<any>(null as any));
var _decl0_94:i9.PropDataDirective<any> = (<any>(null as any));
var _decl0_95:i9.DisabledDirective = (<any>(null as any));
var _decl0_96:i10.SVContainerComponent = (<any>(null as any));
var _decl0_97:i10.SVComponent = (<any>(null as any));
var _decl0_98:i10.SVTitleComponent = (<any>(null as any));
var _decl0_99:i10.SVValueComponent = (<any>(null as any));
var _decl0_100:i11.ɵNzTransitionPatchDirective = (<any>(null as any));
var _decl0_101:i12.NzWaveDirective = (<any>(null as any));
var _decl0_102:i13.NzButtonComponent = (<any>(null as any));
var _decl0_103:i13.NzButtonGroupComponent = (<any>(null as any));
var _decl0_104:i14.NzMenuDirective = (<any>(null as any));
var _decl0_105:i14.NzMenuItemDirective = (<any>(null as any));
var _decl0_106:i14.NzSubMenuComponent = (<any>(null as any));
var _decl0_107:i14.NzMenuDividerDirective = (<any>(null as any));
var _decl0_108:i14.NzMenuGroupComponent = (<any>(null as any));
var _decl0_109:i15.NzDropDownDirective = (<any>(null as any));
var _decl0_110:i15.NzDropDownADirective = (<any>(null as any));
var _decl0_111:i15.NzDropdownMenuComponent = (<any>(null as any));
var _decl0_112:i15.NzDropdownButtonDirective = (<any>(null as any));
var _decl0_113:i16.NzIconDirective = (<any>(null as any));
var _decl0_114:i17.NzTableComponent<any> = (<any>(null as any));
var _decl0_115:i17.NzThAddOnComponent = (<any>(null as any));
var _decl0_116:i17.NzTableCellDirective = (<any>(null as any));
var _decl0_117:i17.NzThMeasureDirective = (<any>(null as any));
var _decl0_118:i17.NzTdAddOnComponent = (<any>(null as any));
var _decl0_119:i17.NzTheadComponent = (<any>(null as any));
var _decl0_120:i17.NzTbodyComponent = (<any>(null as any));
var _decl0_121:i17.NzTrDirective = (<any>(null as any));
var _decl0_122:i17.NzTableVirtualScrollDirective = (<any>(null as any));
var _decl0_123:i17.NzCellFixedDirective = (<any>(null as any));
var _decl0_124:i17.NzFilterTriggerComponent = (<any>(null as any));
var _decl0_125:i17.NzTrExpandDirective = (<any>(null as any));
var _decl0_126:i17.NzCellBreakWordDirective = (<any>(null as any));
var _decl0_127:i17.NzCellAlignDirective = (<any>(null as any));
var _decl0_128:i17.NzCellEllipsisDirective = (<any>(null as any));
var _decl0_129:i17.NzTableFixedRowComponent = (<any>(null as any));
var _decl0_130:i17.NzThSelectionComponent = (<any>(null as any));
var _decl0_131:i18.NzSpinComponent = (<any>(null as any));
var _decl0_132:i19.ExtensibleTableComponent<any> = (<any>(null as any));
var _decl0_133:i20.NzTableRowDetailDirective = (<any>(null as any));
var _decl0_134:i21.GridActionsComponent<any> = (<any>(null as any));
var _decl0_135:i22.PageToolbarComponent<any> = (<any>(null as any));
var _decl0_136:i23.NzTableListDirective = (<any>(null as any));
var _decl0_137:i24.NzSelectDefaultDirective<any> = (<any>(null as any));
var _decl0_138:i25.NzSelectLoadingComponent = (<any>(null as any));
var _decl0_139:i2.AsyncPipe = (<any>(null as any));
var _decl0_140:i2.UpperCasePipe = (<any>(null as any));
var _decl0_141:i2.LowerCasePipe = (<any>(null as any));
var _decl0_142:i2.JsonPipe = (<any>(null as any));
var _decl0_143:i2.SlicePipe = (<any>(null as any));
var _decl0_144:i2.DecimalPipe = (<any>(null as any));
var _decl0_145:i2.PercentPipe = (<any>(null as any));
var _decl0_146:i2.TitleCasePipe = (<any>(null as any));
var _decl0_147:i2.CurrencyPipe = (<any>(null as any));
var _decl0_148:i2.DatePipe = (<any>(null as any));
var _decl0_149:i2.I18nPluralPipe = (<any>(null as any));
var _decl0_150:i2.I18nSelectPipe = (<any>(null as any));
var _decl0_151:i2.KeyValuePipe = (<any>(null as any));
var _decl0_152:i5.ɵb = (<any>(null as any));
var _decl0_153:i5.ɵba = (<any>(null as any));
var _decl0_154:i5.CoreModule = (<any>(null as any));
var _decl0_155:i7.ThemeSharedModule = (<any>(null as any));
var _decl0_156:i8.NgxValidateCoreModule = (<any>(null as any));
var _decl0_157:i9.UiExtensionsModule = (<any>(null as any));
var _decl0_158:i10.SVModule = (<any>(null as any));
var _decl0_159:i13.NzButtonModule = (<any>(null as any));
var _decl0_160:i15.NzDropDownModule = (<any>(null as any));
var _decl0_161:i16.NzIconModule = (<any>(null as any));
var _decl0_162:i17.NzTableModule = (<any>(null as any));
var _decl0_163:i18.NzSpinModule = (<any>(null as any));
var _decl0_164:i0.TemplateRef<any> = (<any>(null as any));
var _decl0_165:i0.ElementRef<any> = (<any>(null as any));
function _View_ExtensibleTableComponent_Host_1_0():void {
  var _any:any = (null as any);
  const currVal_0:any = _decl0_132.responsive;
  currVal_0;
}
function _View_ExtensibleTableComponent_1_1():void {
  if (_decl0_132.haveRowDetail) {
    var _any:any = (null as any);
    const currVal_0:any = _decl0_116.isInsideTable;
    currVal_0;
    const currVal_1:any = '50px';
    currVal_1;
  }
}
function _View_ExtensibleTableComponent_1_3():void {
  if (!!_any.sortable) {
    var _any:any = (null as any);
    const currVal_0:any = _any.name;
    currVal_0;
    const currVal_1:any = ['ascend','descend'];
    currVal_1;
    const currVal_2:any = _any.sortable;
    currVal_2;
    const currVal_3:any = _decl0_115.nzShowSort;
    currVal_3;
    const currVal_4:any = ((_decl0_115.sortOrder === 'descend') || (_decl0_115.sortOrder === 'ascend'));
    currVal_4;
    const currVal_5:any = _decl0_116.isInsideTable;
    currVal_5;
    const currVal_6:any = (_any.columnWidth + 'px');
    currVal_6;
    const currVal_7:any = _decl0_152.transform(_any.displayName);
    currVal_7;
    const pd_8:any = ((<any>_decl0_115.emitNextSortValue()) !== false);
  }
}
function _View_ExtensibleTableComponent_1_4():void {
  var _any:any = (null as any);
  const currVal_0:any = _any.name;
  currVal_0;
  const currVal_1:any = ['ascend','descend'];
  currVal_1;
  const currVal_2:any = _decl0_115.nzShowSort;
  currVal_2;
  const currVal_3:any = ((_decl0_115.sortOrder === 'descend') || (_decl0_115.sortOrder === 'ascend'));
  currVal_3;
  const currVal_4:any = _decl0_116.isInsideTable;
  currVal_4;
  const currVal_5:any = (_any.columnWidth + 'px');
  currVal_5;
  const currVal_6:any = _decl0_152.transform(_any.displayName);
  currVal_6;
  const pd_7:any = ((<any>_decl0_115.emitNextSortValue()) !== false);
}
function _View_ExtensibleTableComponent_1_2():void {
  var _any:any = (null as any);
  const currVal_0:any = !!_any.sortable;
  currVal_0;
  const currVal_1:any = _decl0_164;
  currVal_1;
}
function _View_ExtensibleTableComponent_1_6():void {
  if (_decl0_132.haveRowDetail) {
    var _any:any = (null as any);
    const currVal_0:any = _decl0_116.isInsideTable;
    currVal_0;
    const currVal_1:any = _decl0_132.expandSet.has(_any['id']);
    currVal_1;
    const currVal_2:any = (_decl0_118.nzShowExpand || (_decl0_118.nzIndentSize > 0));
    currVal_2;
    const currVal_3:any = _decl0_118.nzShowCheckbox;
    currVal_3;
    const pd_4:any = ((<any>_decl0_132.onExpandChange(_any['id'],_any)) !== false);
  }
}
function _View_ExtensibleTableComponent_1_8():void {
  if (!_decl0_132.scroll) {
    var _any:any = (null as any);
    const currVal_0:any = _decl0_152.transform(_any.displayName);
    currVal_0;
  }
}
function _View_ExtensibleTableComponent_1_9():void {
  if (_any[('_' + _any.name)].visible) {
    var _any:any = (null as any);
    const currVal_0:any = _decl0_139.transform(_any[('_' + _any.name)].value);
    currVal_0;
    const currVal_1:any = _any.action;
    currVal_1;
    const pd_2:any = ((<any>(_any.action && _any.action({getInjected:_decl0_132.getInjected,
        record:_any,index:_any}))) !== false);
  }
}
function _View_ExtensibleTableComponent_1_7():void {
  var _any:any = (null as any);
  const currVal_0:any = _decl0_116.isInsideTable;
  currVal_0;
  const currVal_1:any = !_decl0_132.scroll;
  currVal_1;
  const currVal_2:any = _any[('_' + _any.name)].visible;
  currVal_2;
  const pd_3:any = ((<any>_decl0_132.selected(_any)) !== false);
}
function _View_ExtensibleTableComponent_1_10():void {
  var _any:any = (null as any);
}
function _View_ExtensibleTableComponent_1_12():void {
  var _any:any = (null as any);
}
function _View_ExtensibleTableComponent_1_11():void {
  var _any:any = (null as any);
  const currVal_0:any = {$implicit:_any};
  currVal_0;
  const currVal_1:any = (_decl0_132.rowDetailTemplate? ((_decl0_132.rowDetailTemplate == null)? (null as any): _decl0_132.rowDetailTemplate.template): _decl0_164);
  currVal_1;
}
function _View_ExtensibleTableComponent_1_15():void {
  if (_any[('_' + _any.name)].visible) {
    var _any:any = (null as any);
    const currVal_0:any = _decl0_152.transform(_any.displayName);
    currVal_0;
    const currVal_1:any = _decl0_97.paddingValue;
    currVal_1;
    const currVal_2:any = _decl0_97.paddingValue;
    currVal_2;
    const currVal_3:any = _decl0_139.transform(_any[('_' + _any.name)].value);
    currVal_3;
  }
}
function _View_ExtensibleTableComponent_1_14():void {
  var _any:any = (null as any);
  const currVal_0:any = _any[('_' + _any.name)].visible;
  currVal_0;
}
function _View_ExtensibleTableComponent_1_13():void {
  var _any:any = (null as any);
  const currVal_0:any = _decl0_132.svRowCount;
  currVal_0;
  const currVal_1:any = true;
  currVal_1;
  const currVal_2:any = (_decl0_96.layout === 'horizontal');
  currVal_2;
  const currVal_3:any = (_decl0_96.layout === 'vertical');
  currVal_3;
  const currVal_4:any = (_decl0_96.size === 'small');
  currVal_4;
  const currVal_5:any = (_decl0_96.size === 'large');
  currVal_5;
  const currVal_6:any = true;
  currVal_6;
  const currVal_7:any = _decl0_132.propList;
  currVal_7;
  const currVal_8:any = _decl0_132.trackByFn;
  currVal_8;
}
function _View_ExtensibleTableComponent_1_5():void {
  var _any:any = (null as any);
  const currVal_0:any = 'bg-white';
  currVal_0;
  const currVal_1:any = {listSelected:(_any['id'] == _decl0_132.selectId),pointer:_decl0_132.haveSelect};
  currVal_1;
  const currVal_2:any = _decl0_121.isInsideTable;
  currVal_2;
  const currVal_3:any = _decl0_116.isInsideTable;
  currVal_3;
  const currVal_4:any = _any;
  currVal_4;
  const currVal_5:any = _decl0_132.haveRowDetail;
  currVal_5;
  const currVal_6:any = _decl0_132.propList;
  currVal_6;
  const currVal_7:any = _decl0_132.trackByFn;
  currVal_7;
  const currVal_8:any = _decl0_132.expandSet.has(_any['id']);
  currVal_8;
  const currVal_9:any = !_decl0_125.nzExpand;
  currVal_9;
  const currVal_10:any = {$implicit:_any};
  currVal_10;
  const currVal_11:any = _decl0_164;
  currVal_11;
}
function _View_ExtensibleTableComponent_1_0():void {
  var _any:any = (null as any);
  const currVal_0:any = _decl0_132.recordsTotal;
  currVal_0;
  const currVal_1:any = _decl0_132.data;
  currVal_1;
  const currVal_2:any = _decl0_132.scroll;
  currVal_2;
  const currVal_3:any = _decl0_139.transform(_decl0_132.list.isLoading$);
  currVal_3;
  const currVal_4:any = (_decl0_114.dir === 'rtl');
  currVal_4;
  const currVal_5:any = _decl0_132.list;
  currVal_5;
  const currVal_6:any = _decl0_121.isInsideTable;
  currVal_6;
  const currVal_7:any = _decl0_116.isInsideTable;
  currVal_7;
  const currVal_8:any = '50px';
  currVal_8;
  const currVal_9:any = _decl0_132.haveRowDetail;
  currVal_9;
  const currVal_10:any = _decl0_132.propList;
  currVal_10;
  const currVal_11:any = _decl0_132.trackByFn;
  currVal_11;
  const currVal_12:any = _decl0_120.isInsideTable;
  currVal_12;
  const currVal_13:any = _decl0_132.data;
  currVal_13;
}
function _View_GridActionsComponent_Host_2_0():void {
  var _any:any = (null as any);
}
function _View_GridActionsComponent_2_4():void {
  if (((_decl0_134.actionList.length > 0) && _any.visible(_decl0_134.data))) {
    var _any:any = (null as any);
    const currVal_0:any = _decl0_105.isMenuInsideDropDown;
    currVal_0;
    const currVal_1:any = (_decl0_105.isMenuInsideDropDown && _decl0_105.nzSelected);
    currVal_1;
    const currVal_2:any = (_decl0_105.isMenuInsideDropDown && _decl0_105.nzDanger);
    currVal_2;
    const currVal_3:any = (_decl0_105.isMenuInsideDropDown && _decl0_105.nzDisabled);
    currVal_3;
    const currVal_4:any = !_decl0_105.isMenuInsideDropDown;
    currVal_4;
    const currVal_5:any = (!_decl0_105.isMenuInsideDropDown && _decl0_105.nzSelected);
    currVal_5;
    const currVal_6:any = (!_decl0_105.isMenuInsideDropDown && _decl0_105.nzDanger);
    currVal_6;
    const currVal_7:any = (!_decl0_105.isMenuInsideDropDown && _decl0_105.nzDisabled);
    currVal_7;
    const currVal_8:any = ((_decl0_105.dir === 'rtl')? null: (_decl0_105.nzPaddingLeft || _decl0_105.inlinePaddingLeft));
    currVal_8;
    const currVal_9:any = ((_decl0_105.dir === 'rtl')? (_decl0_105.nzPaddingLeft || _decl0_105.inlinePaddingLeft): null);
    currVal_9;
    const currVal_10:any = _decl0_152.transform(_any.text);
    currVal_10;
    const pd_11:any = ((<any>_decl0_105.clickMenuItem(_any)) !== false);
    const pd_12:any = ((<any>_any.action(_decl0_134.data)) !== false);
  }
}
function _View_GridActionsComponent_2_3():void {
  if ((_decl0_134.actionList.length > 0)) {
    var _any:any = (null as any);
    const currVal_0:any = _any.visible(_decl0_134.data);
    currVal_0;
  }
}
function _View_GridActionsComponent_2_2():void {
  if ((_decl0_134.actionList.length > 0)) {
    var _any:any = (null as any);
    const currVal_0:any = _any.permission;
    currVal_0;
  }
}
function _View_GridActionsComponent_2_1():void {
  if ((_decl0_134.actionList.length > 0)) {
    var _any:any = (null as any);
    const currVal_0:any = _decl0_111;
    currVal_0;
    const currVal_1:any = _decl0_152.transform('AbpUi::Actions');
    currVal_1;
    const currVal_2:any = 'down';
    currVal_2;
    const currVal_3:any = true;
    currVal_3;
    const currVal_4:any = _decl0_104.isMenuInsideDropDown;
    currVal_4;
    const currVal_5:any = _decl0_104.isMenuInsideDropDown;
    currVal_5;
    const currVal_6:any = (_decl0_104.isMenuInsideDropDown && (_decl0_104.nzTheme === 'light'));
    currVal_6;
    const currVal_7:any = (_decl0_104.isMenuInsideDropDown && (_decl0_104.nzTheme === 'dark'));
    currVal_7;
    const currVal_8:any = (_decl0_104.isMenuInsideDropDown && (_decl0_104.actualMode === 'vertical'));
    currVal_8;
    const currVal_9:any = (_decl0_104.isMenuInsideDropDown && (_decl0_104.actualMode === 'horizontal'));
    currVal_9;
    const currVal_10:any = (_decl0_104.isMenuInsideDropDown && (_decl0_104.actualMode === 'inline'));
    currVal_10;
    const currVal_11:any = (_decl0_104.isMenuInsideDropDown && _decl0_104.nzInlineCollapsed);
    currVal_11;
    const currVal_12:any = !_decl0_104.isMenuInsideDropDown;
    currVal_12;
    const currVal_13:any = !_decl0_104.isMenuInsideDropDown;
    currVal_13;
    const currVal_14:any = (!_decl0_104.isMenuInsideDropDown && (_decl0_104.nzTheme === 'light'));
    currVal_14;
    const currVal_15:any = (!_decl0_104.isMenuInsideDropDown && (_decl0_104.nzTheme === 'dark'));
    currVal_15;
    const currVal_16:any = (!_decl0_104.isMenuInsideDropDown && (_decl0_104.actualMode === 'vertical'));
    currVal_16;
    const currVal_17:any = (!_decl0_104.isMenuInsideDropDown && (_decl0_104.actualMode === 'horizontal'));
    currVal_17;
    const currVal_18:any = (!_decl0_104.isMenuInsideDropDown && (_decl0_104.actualMode === 'inline'));
    currVal_18;
    const currVal_19:any = (!_decl0_104.isMenuInsideDropDown && _decl0_104.nzInlineCollapsed);
    currVal_19;
    const currVal_20:any = (_decl0_104.dir === 'rtl');
    currVal_20;
    const currVal_21:any = _decl0_134.actionList;
    currVal_21;
    const currVal_22:any = _decl0_134.trackByFn;
    currVal_22;
  }
}
function _View_GridActionsComponent_2_0():void {
  var _any:any = (null as any);
  const currVal_0:any = (_decl0_134.actionList.length > 0);
  currVal_0;
}
function _View_PageToolbarComponent_Host_3_0():void {
  var _any:any = (null as any);
}
function _View_PageToolbarComponent_3_5():void {
  if ((_any.visible(_decl0_135.data) && _any.component)) { var _any:any = (null as any); }
}
function _View_PageToolbarComponent_3_4():void {
  if ((_any.visible(_decl0_135.data) && _any.component)) {
    var _any:any = (null as any);
    const currVal_0:any = _any;
    currVal_0;
    const currVal_1:any = _decl0_135.createInjector(_any);
    currVal_1;
  }
}
function _View_PageToolbarComponent_3_6():void {
  if (_any.visible(_decl0_135.data)) {
    var _any:any = (null as any);
    const currVal_0:any = 'primary';
    currVal_0;
    const currVal_1:any = (_decl0_102.nzType === 'primary');
    currVal_1;
    const currVal_2:any = (_decl0_102.nzType === 'dashed');
    currVal_2;
    const currVal_3:any = (_decl0_102.nzType === 'link');
    currVal_3;
    const currVal_4:any = (_decl0_102.nzType === 'text');
    currVal_4;
    const currVal_5:any = (_decl0_102.nzType === 'danger');
    currVal_5;
    const currVal_6:any = (_decl0_102.nzShape === 'circle');
    currVal_6;
    const currVal_7:any = (_decl0_102.nzShape === 'round');
    currVal_7;
    const currVal_8:any = (_decl0_102.nzSize === 'large');
    currVal_8;
    const currVal_9:any = (_decl0_102.nzSize === 'small');
    currVal_9;
    const currVal_10:any = _decl0_102.nzDanger;
    currVal_10;
    const currVal_11:any = _decl0_102.nzLoading;
    currVal_11;
    const currVal_12:any = _decl0_102.nzGhost;
    currVal_12;
    const currVal_13:any = _decl0_102.nzBlock;
    currVal_13;
    const currVal_14:any = _decl0_102.nzSearch;
    currVal_14;
    const currVal_15:any = (_decl0_102.dir === 'rtl');
    currVal_15;
    const currVal_16:any = (_decl0_102.disabled? (-1): ((_decl0_102.tabIndex === null)? null: _decl0_102.tabIndex));
    currVal_16;
    const currVal_17:any = (_decl0_102.disabled || null);
    currVal_17;
    const currVal_18:any = _any.icon;
    currVal_18;
    const currVal_19:any = _any.icon;
    currVal_19;
    const currVal_20:any = _decl0_152.transform(_any.text);
    currVal_20;
    const pd_21:any = ((<any>_any.action(_decl0_135.data)) !== false);
  }
}
function _View_PageToolbarComponent_3_3():void {
  if (_any.visible(_decl0_135.data)) {
    var _any:any = (null as any);
    const currVal_0:any = _any.component;
    currVal_0;
    const currVal_1:any = _decl0_164;
    currVal_1;
  }
}
function _View_PageToolbarComponent_3_2():void {
  if (_any.visible(_decl0_135.data)) {
    var _any:any = (null as any);
    const currVal_0:any = _any.permission;
    currVal_0;
  }
}
function _View_PageToolbarComponent_3_1():void {
  var _any:any = (null as any);
  const currVal_0:any = _any.visible(_decl0_135.data);
  currVal_0;
}
function _View_PageToolbarComponent_3_0():void {
  var _any:any = (null as any);
  const currVal_0:any = _decl0_135.actionList;
  currVal_0;
  const currVal_1:any = _decl0_135.trackByFn;
  currVal_1;
}
function _View_NzSelectLoadingComponent_Host_4_0():void {
  var _any:any = (null as any);
}
function _View_NzSelectLoadingComponent_4_2():void {
  if (_decl0_139.transform(_decl0_138.isLoading$)) {
    var _any:any = (null as any);
    const currVal_0:any = !_decl0_131.nzSimple;
    currVal_0;
  }
}
function _View_NzSelectLoadingComponent_4_1():void {
  var _any:any = (null as any);
  const currVal_0:any = _decl0_139.transform(_decl0_138.isLoading$);
  currVal_0;
}
function _View_NzSelectLoadingComponent_4_0():void {
  var _any:any = (null as any);
}
